import { List, ListItemButton, Collapse } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import React, { useState } from "react";

const NestedList = ({ active, item, clickHandler, sx, catId }) => {
  const [open, setOpen] = useState(false);
  if (item?.children.length > 0) {
    return (
      <>
        <ListItemButton
          style={{
            background: active ? "var(--main-color)" : "",
            color: active ? "var(--second-color)" : "",
          }}
          sx={sx}
          className={`sidebar__item `}
          onClick={() => setOpen(!open)}
          onDoubleClick={() => clickHandler(item.id)}
        >
          <div className={`sidebar__item-inner `}>
            <span className="me-2">{item.nameRu}</span>
            {open ? <ExpandLess /> : <ExpandMore />}
          </div>
        </ListItemButton>

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {item.children.map((v, index) => (
              <NestedList
                key={index}
                sx={{ pl: 5 }}
                clickHandler={clickHandler}
                item={v}
                active={v.id === catId}
                catId={catId}
              />
            ))}
          </List>
        </Collapse>
      </>
    );
  } else
    return (
      <ListItemButton
        key={item.id}
        sx={sx}
        style={{
          background: active ? "var(--third-color-blue)" : "",
          width: "100%",
        }}
        onClick={() => clickHandler(item.id)}
      >
        <div className={`sidebar__item-inner `}>
          <span>{item.nameRu}</span>
        </div>
      </ListItemButton>
    );
};

export default NestedList;
